// extracted by mini-css-extract-plugin
export default {"rightsTxt":"FooterCopyright_rightsTxt__WXiJe","rightsLink":"FooterCopyright_rightsLink__BxgQY"};